import { Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import ServiceDetail from './components/ServiceDetail';
import PaymentTerms from './components/PaymentTerms';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';

const AppRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Services />
            <Gallery />
            <Contact />
          </>
        } />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/payment-terms" element={<PaymentTerms />} />
      </Routes>
      <ScrollToTop />
      <WhatsAppButton />
    </>
  );
};

export default AppRoutes; 